class BSO_BULK_PRICE_DISPLAY extends HTMLElement {
  constructor() {
    super();

    this.config = JSON.parse(this.getAttribute('data-bulk-prices-config') || null);
    this.bulkprices = this.querySelectorAll('.price__default');

    this.quantitys = [];
    if (this.config) {
      this.quantitys = [1, ...this.config.map((item) => item.amount)];
    }
  }

  connectedCallback() {
    document.addEventListener('quantity:changed', this.selectBulkPrice.bind(this));
    document.addEventListener('quantity:changed:bulk:button', this.selectBulkPrice.bind(this));
  }

  selectBulkPrice(e) {
    const inputQuantity = Number(e.detail);
    const quantitys = this.quantitys.sort((a, b) => a - b).reverse();

    for (const bulkprice of this.bulkprices) {
      bulkprice.classList.add('hidden');
    }

    for (const quantity of quantitys) {
      if (inputQuantity >= quantity) {
        this.querySelector(`.price__default[data-amount="${quantity}"]`).classList.remove('hidden');
        break
      }
    }
  }
}

customElements.define('bso-bulk-price-display', BSO_BULK_PRICE_DISPLAY);
